function enablePopover() {
    $('[data-toggle="popover"]').popover()
}

export { enablePopover }